var _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveNatification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25C17.2417 25 18.249 23.9928 18.249 22.75H13.7511C13.7511 23.9928 14.7583 25 16 25ZM23.5723 19.7368C22.8931 19.0069 21.6222 17.909 21.6222 14.3125C21.6222 11.5809 19.7069 9.39414 17.1243 8.85766V8.125C17.1243 7.50379 16.6209 7 16 7C15.3792 7 14.8757 7.50379 14.8757 8.125V8.85766C12.2931 9.39414 10.3778 11.5809 10.3778 14.3125C10.3778 17.909 9.10694 19.0069 8.42772 19.7368C8.21678 19.9635 8.12327 20.2346 8.12502 20.5C8.12889 21.0766 8.58135 21.625 9.25354 21.625H22.7465C23.4187 21.625 23.8715 21.0766 23.875 20.5C23.8768 20.2346 23.7833 19.9632 23.5723 19.7368Z",
    fill: "#242731"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.625,
    cy: 9.25,
    r: 3.375,
    fill: "url(#paint0_linear_3422:11507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3422:11507",
    x1: 18.25,
    y1: 5.875,
    x2: 26.3768,
    y2: 8.80064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED6044"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNatification);
export default __webpack_public_path__ + "static/media/activeNatification.0c9779fb13b97d654412f2a3576b6b42.svg";
export { ForwardRef as ReactComponent };